export default "__VITE_ASSET__8541deeb__"